

class PersistStorage {
    static save(key, data, expirationInMinutes, useLocalStorage = false) {
        try {
            const storage = useLocalStorage ? localStorage : sessionStorage;
            const expirationMS = expirationInMinutes * 60 * 1000; // Convert minutes to milliseconds
            const record = {
                data: data,
                expiration: new Date().getTime() + expirationMS
            };
            storage.setItem(key, JSON.stringify(record));
        } catch (e) {
            console.error("Error saving data in StorageHelper:", e);
            // Handle the error appropriately
            // You might want to throw the error, return false, call an error callback, etc.
        }
    }

    static retrieve(key, useLocalStorage = false) {
        try {
            const storage = useLocalStorage ? localStorage : sessionStorage;
            const record = JSON.parse(storage.getItem(key));
            if (!record) {
                return null;
            }
            if (new Date().getTime() > record.expiration) {
                storage.removeItem(key);
                return null;
            }
            return record.data;
        } catch (e) {
            console.error("Error retrieving data in StorageHelper:", e);
            // Handle the error appropriately
            // You might want to throw the error, return null, call an error callback, etc.
            return null; // For example, returning null in case of an error
        }
    }
};

export default PersistStorage;